import React, { createContext, useState } from "react";
import { langsType } from "../types/enums/API.types";

interface langContextType {
  lang_id: string;
  lang: string;
  setLang: (lang: langsType) => void;
}

const inititalLangContext: langContextType = {
  lang_id: "",
  lang: "",
  setLang: () => {},
};

export const LangContext = createContext<langContextType>(inititalLangContext);

export const LanguageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [lang, setLang] = useState<langsType>({
    id: "",
    lang: "",
    lang_code: "",
    lang_type: "",
  });

  const changeLang = (lang: langsType) => {
    setLang(lang);
  };

  return (
    <LangContext.Provider
      value={{ lang_id: lang.id, lang: lang.lang, setLang: changeLang }}
    >
      {children}
    </LangContext.Provider>
  );
};

export default LangContext;
